
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "CFSC",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/CFSC.vue